<template>
  <img v-if="model" :src="getUrl()" />
  <img v-else :src="defaultImageSrc" />
</template>

<script>
export default {
  name: "vehicle-image",
  props: ["thumb", "model"],
  data() {
    return {
      defaultImageSrc: "/frontend/img/sample-car.png"
    };
  },
  methods: {
    getUrl() {
      if (this.thumb === false) return this.model.url;
      if (this.thumb && this.model[this.thumb]) return this.model[this.thumb];

      return this.model.thumb_url || this.model.url;
    },
    onBookClick() {
      this.$emit("book", this.model);
    }
  }
};
</script>
